<template>
  <div class="panel-body">
<v-dialog
      v-model="usersDialog"
      width="500"
    >
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Id
          </th>
          <th class="text-left">
            Email
          </th>
          <th class="text-left">
            Name
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in users"
          :key="item.quberUsername"
        >
          <td>{{ item.userId }}</td>
          <td>{{ item.quberUserName }}</td>
          <td>{{ item.firstName }} {{ item.lastName }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  </v-dialog>
    <v-card>
      <v-card-title>{{getTitle}}
        <v-icon
          class="pl-2 pr-2"
          color="primary"
          medium
          @click="showUsers"
        >
          mdi-account-multiple-plus
        </v-icon>
        {{getTitle2}}
      </v-card-title>
      <template>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-switch v-model="everyDayUntilEnd" color="primary" class="mt-2" label="Display daily until end date?"></v-switch>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-if="!this.everyDayUntilEnd"
                v-model="questionnaireUserAccess.maxShow"
                class="onlyDigitInput"
                label="Number of times to repeat question"
                type="number"
                required
                hint="0 means the user will see once and never repeat"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="displayStartDateTime"
                    label="Start Date"
                    persistent-hint
                    hint="Choose date/time for question to start."
                    class="mr-1"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                  />
                </template>
                <v-card>
                  <v-date-picker v-model="displayStartDate" :min="nowDate" :max="getEndDate">
                  </v-date-picker>
                  <v-time-picker
                    v-model="displayStartTime"
                    format="24hr"
                    @click:minute="startDateMenu = false;setStartDateTime()"
                  >
                  </v-time-picker>
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right">
                    <v-btn text color="red" @click="startDateMenu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="startDateMenu = false;setStartDateTime()">OK</v-btn>
                  </v-flex>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="displayEndDateTime"
                    label="End Date"
                    persistent-hint
                    hint="Choose end date/time for question."
                    class="ml-1"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                  />
                </template>
                <v-card>
                  <v-date-picker v-model="displayEndDate" :min="nowDate" :max="getEndDate">
                  </v-date-picker>
                  <v-time-picker
                    v-model="displayEndTime"
                    format="24hr"
                    @click:minute="endDateMenu = false;setEndDateTime()"
                  />
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right">
                    <v-btn text color="red" @click="endDateMenu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="endDateMenu = false;setEndDateTime()">OK</v-btn>
                  </v-flex>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-slider
                v-model="questionnaireUserAccess.priority"
                class="mt-2"
                label="Priority"
                :max="max"
                :min="min"
                thumb-label="always"
                :thumb-size="18"
                :thumb-color="pickerThumbColour"
                @change="validatePriorityChange"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"></v-col>
            <v-col cols="1">
              <v-btn
                @click="close"
              >Cancel</v-btn>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="1">
              <v-btn
                color="primary"
                :disabled="!questionnaireUserAccess"
                @click="saveAccess"
              >Save</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'

let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    questionnaire: {
      required: true,
      type: Object
    },
    users: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    dialog: false,
    usersDialog: false,
    everyDayUntilEnd: true,
    min: 0,
    max: 10,
    pickerThumbColour: 'primary',
    direction: 'top',
    displayTitle: '',
    valid: true,
    questionnaireUserAccess: {
      questionnaireId: null,
      userIds: null,
      maxShow: null,
      startDate: null,
      endDate: null,
      priority: null,
      excluded: false
    },
    startDateMenu: null,
    startTimeMenu: null,
    endDateMenu: null,
    endTimeMenu: null,
    localDate: null,
    nowDate: moment().format('YYYY-MM-DD HH:mm'),
    date: new Date(),
    picker: new Date().toISOString().substr(0, 10),
    dateTimeDialog: false,
    displayStartDate: null,
    displayStartTime: null,
    displayStartDateTime: null,
    displayEndDate: null,
    displayEndTime: null,
    displayEndDateTime: null,
    todaysDate: moment(new Date()).toISOString,
    maxDate: moment().add(365, 'days').calendar().toISOString
  }),

  created () {
    this.initialize()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dateTimeDialog (val) {},
    usersDialog (val) {},
    users: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (newValue != null) {
          this.questionnaireUserAccess.userIds = newValue.map(
            (i) => i.userId
          )
        }
      }
    },
    questionnaire: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.questionnaireUserAccess.questionnaireId = newValue.id

        // Check for null or 0
        if (this.questionnaireUserAccess.priority == null || this.questionnaireUserAccess.priority === 0) {
          this.questionnaireUserAccess.priority = null
          this.pickerThumbColour = 'red'
        } else {
          this.pickerThumbColour = 'primary'
        }
        this.initialize()
      }
    }
  },
  computed: {
    getTitle () {
      return 'Adding ' + this.questionnaireUserAccess.userIds.length + ' users'
    },
    getTitle2 () {
      return 'to the ' + this.questionnaire.name + ' (' + this.questionnaire.id + ') question  '
    },
    getEndDate () {
      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 12, 10)
      return endDate.toISOString().slice(0, 10)
    }
  },
  methods: {
    initialize () {
      this.questionnaireUserAccess = {
        questionnaireId: this.questionnaire.id,
        active: true,
        userIds: this.questionnaireUserAccess.userIds,
        maxShow: 3,
        startDate: null,
        endDate: null,
        priority: null,
        excluded: false
      }

      this.displayStartDate = this.formatDate(this.nowDate)
      this.displayStartTime = this.formatTime(this.nowDate)
      this.displayStartDateTime = this.formatDateTime(this.nowDate)
      this.localDate = moment().add(30, 'd').format('YYYY-MM-DD HH:mm')
      this.displayEndDate = this.formatDate(this.localDate)
      this.displayEndTime = this.formatTime(this.localDate)
      this.displayEndDateTime = this.formatDateTime(this.localDate)
      this.setStartDateTime()
      this.setEndDateTime()
    },
    close () {
      this.dialog = false
      this.$emit('close-questionnaire-access-dialog')
    },
    showUsers () {
      this.usersDialog = true
    },
    validatePriorityChange () {
      if (this.questionnaireUserAccess.priority === 0) {
        this.pickerThumbColour = 'red'
        this.questionnaireUserAccess.priority = null
      } else {
        this.pickerThumbColour = 'primary'
      }
    },
    async saveAccess () {
      if (!this.questionnaireUserAccess.userIds || this.questionnaireUserAccess.userIds.length < 1) {
        alert('Something went wrong, the user ids are not set')
        return
      }
      if (!this.questionnaire || !this.questionnaire.id) {
        alert('Something went wrong, the questionnaire id is not set')
        return
      }

      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires/${this.questionnaire.id}/access`

      if (this.everyDayUntilEnd) {
        this.questionnaireUserAccess.maxShow = null
      }
      if (this.questionnaireUserAccess.priority === 0) {
        this.questionnaireUserAccess.priority = null
      }

      var body = [this.questionnaireUserAccess]

      // Stringify questionnaireUserAccess
      body = JSON.stringify(body)
      this.isSending = true
      var postResponse = await rh.default.post(endpoint, body, true).catch(e => {
        this.errors.push(e)
      }).finally(() => { })

      if (postResponse == null) {
        alert('Failed to configure the selected users to receive questionnaire \'' + this.questionnaire.name + '\'')
      } else if (postResponse.status === 200) {
        alert('Successfully configured ' + postResponse.data.length + ' users to receive questionnaire \'' + this.questionnaire.name + '\'')
      } else {
        alert('Failed to configure the selected users to receive questionnaire \'' + this.questionnaire.name + '\'')
      }
      this.dialog = false
      this.initialize()
      this.$emit('save-questionnaire-access')
    },
    setStartDateTime () {
      this.localDate = moment(
        this.displayStartDate + ' ' + this.displayStartTime
      )
      this.questionnaireUserAccess.startDate = moment.utc(this.localDate).toISOString()
      this.displayStartDate = this.formatDate(this.questionnaireUserAccess.startDate)
      this.displayStartTime = this.formatTime(this.questionnaireUserAccess.startDate)
      this.displayStartDateTime = this.formatDateTime(this.questionnaireUserAccess.startDate)
    },
    clearEndDateTime () {
      this.questionnaireUserAccess.endDate = null
      this.localDate = null
      this.displayEndDate = ''
      this.displayEndTime = ''
      this.displayEndDateTime = ''
    },
    setEndDateTime () {
      this.localDate = moment(
        this.displayEndDate + ' ' + this.displayEndTime
      )
      this.questionnaireUserAccess.endDate = moment.utc(this.localDate).toISOString()
      this.displayEndDate = this.formatDate(this.localDate)
      this.displayEndTime = this.formatTime(this.localDate)
      this.displayEndDateTime = this.formatDateTime(this.localDate)
    },
    formatDateTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD HH:mm')
    },
    formatDate (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD')
    },
    formatTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('HH:mm')
    }
  }
}
</script>
<style>
.onlyDigitInput input[type="number"] {
  -moz-appearance: textfield;
}
.onlyDigitInput input::-webkit-outer-spin-button,
.onlyDigitInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
